import { useMutation } from "@tanstack/react-query";
import { AxiosError } from "axios";

import { apiClient } from "../../config/apiClient";
import { API } from "../../config/apiConfig";
import { CreateRedirectPayload, CreateRedirectResponse, DeleteRedirectPayload } from "./NetTypes";

async function createRedirectRequest({ orgId, appId, name, redirectURI }: CreateRedirectPayload) {
	return await apiClient
		.post(API.COMMAND.ORGANIZATIONS.REDIRECTS.CREATE(orgId, appId), {
			name,
			redirectURI
		})
		.then((res) => res.data);
}

export function useCreateRedirectApp() {
	return useMutation<CreateRedirectResponse, AxiosError, CreateRedirectPayload>({
		mutationFn: (payload: CreateRedirectPayload) => createRedirectRequest(payload)
	});
}

async function deleteRedirectRequest({ orgId, appId, id }: DeleteRedirectPayload) {
	return await apiClient
		.delete(API.COMMAND.ORGANIZATIONS.REDIRECTS.DELETE(orgId, appId, id))
		.then((res) => res.data);
}

export function useDeleteRedirectApp() {
	return useMutation<any, AxiosError, DeleteRedirectPayload>({
		mutationFn: (payload: DeleteRedirectPayload) => deleteRedirectRequest(payload)
	});
}
